<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
    :minimalize="minimalize"
  >
    <BaseInput
      :label="
        localStorage.translations.pages['setting-work_extra_type']['dialog-add_edit-labels'][
          'nazvanie'
        ]
      "
      v-model="name"
      prepend-inner-icon="mdi-wrench"
      :rules="['required', 'max100']"
      :placeholder="
        localStorage.translations.pages['setting-work_extra_type']['dialog-add_edit-labels'][
          'nazvanie'
        ]
      "
    />
  </TemplateModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'WorkExtraTypeModal',
  props: {
    id: {
      type: [Number, String],
      default: -1,
    },
    create: Boolean,
    minimalize: Boolean,
  },
  data: () => ({
    name: '',
  }),
  computed: {
    ...mapGetters('workExtraType', ['workExtraTypeShow']),
    SettingWorkExtraTypePage() {
      return this.$route.name === 'SettingWorkExtraType'
    },
    t() {
      return this.localStorage.translations.pages['setting-work_extra_type']
    },
    text() {
      return {
        button: {
          open: this.t['dialog-add_edit-buttons']['dobavit'],
        },
        title: {
          create: this.t['dialog-add_edit']['dobavlenie-vida-dopolnitelnyh-rabot'],
          edit: this.t['dialog-add_edit']['redaktirovanie-vida-dopolnitelnyh-rabot'],
        },
      }
    },
  },
  watch: {
    workExtraTypeShow() {
      this.name = this.workExtraTypeShow.name
    },
  },
  methods: {
    ...mapActions('workExtraType', [
      'onWorkExtraTypeShow',
      'onWorkExtraTypeCreate',
      'onWorkExtraTypeGrid',
      'onWorkExtraTypeUpdate',
      'onWorkExtraTypeAll',
    ]),
    async onOpen() {
      if (this.create) {
        this.name = ''
      } else {
        this.onWorkExtraTypeShow(this.id)
      }
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
    },
    async onSave() {
      if (this.create) {
        let data = {
          name: this.name,
        }
        this.onWorkExtraTypeCreate(data)
          .then((response) => {
            if (response) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications['uspeshno-dobavlen'],
                  IsError: false,
                },

                { root: true },
              )
              if (this.SettingWorkExtraTypePage) {
                this.onWorkExtraTypeGrid({
                  limit: this.$route.query.limit,
                  page: this.$route.query.page,
                })
              } else {
                this.onWorkExtraTypeAll()
              }

              this.closeModal()
            }
          })
          .catch((err) => {
            if (err.response.data.name[0]) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'name_is_already_in_use'
                    ],
                  IsError: true,
                },
                { root: true },
              )
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      } else {
        let data = {
          id: this.workExtraTypeShow.id,
          name: this.name,
        }
        this.onWorkExtraTypeUpdate(data)
          .then((response) => {
            if (response) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'izmeneniya-uspeshno-sohraneny'
                    ],
                  IsError: false,
                },

                { root: true },
              )
              this.onWorkExtraTypeGrid({
                limit: this.$route.query.limit,
                page: this.$route.query.page,
              })
              this.closeModal()
            }
          })
          .catch((err) => {
            if (err.response.data.name[0]) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'name_is_already_in_use'
                    ],
                  IsError: true,
                },
                { root: true },
              )
            } else {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common.notifications['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      }
    },
  },
}
</script>